export default __webpack_public_path__ + "static/media/lemonade-headline@2x.fa0f8d92.png";